import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ToasterService, ToasterConfig, Toast } from 'angular2-toaster';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private toasterService: ToasterService;
  constructor( toasterService: ToasterService) { 
    this.toasterService = toasterService;
  }

  public config1 : ToasterConfig = new ToasterConfig({
    positionClass: 'toast-bottom-right'
  });

  popToast(type,title ,timeout, body ) {
    const toast: Toast = {
      type: type,
      title: title,
      timeout: timeout,
      body: body
    };
    this.toasterService.pop(toast);
  }

  downloadFile(data,headerKey ,csvName,title,total) {

    let csvData = this.ConvertToCSV(data, headerKey,title,total);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", csvName + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);

  }


  ConvertToCSV(objArray, headerList,title="",total="") {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row =  title +  '\r\n';
    row += 'NO.,';
    for (let index in headerList) {
        row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
        let line = (i+1)+'';
        for (let index in headerList) {
           let head = headerList[index];

            line += ',' + array[i][head];
        }
        str += line + '\r\n';
    }
    str += " " +  " " + " "+ total;
    return str;
  }
}
